var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-combobox',{attrs:{"label":_vm.customLabel,"items":_vm.items,"item-text":"name","item-value":"name","outlined":_vm.outlined},on:{"blur":_vm.onBlur,"change":_vm.onChange},model:{value:(_vm.pickupPoint),callback:function ($$v) {_vm.pickupPoint=$$v},expression:"pickupPoint"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a96cab3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gt/shared/PickupPointListSelect.vue
// module id = null
// module chunks = 